"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var http_1 = require("@angular/common/http");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/operator/map");
require("rxjs/add/operator/filter");
require("rxjs/add/operator/skip");
require("rxjs/add/operator/take");
/**
 * Dummy implementation of MessageService
 * @author gnuni.gevorgyan
 */
var DummyMessageService = /** @class */ (function () {
    /**
     * Construct HttpMessageService's instance
     * Get message service api url from applicationPropertiesService
     * and load by this url all available messages from server or from local json file by
     * @param http
     * @param currentLanguageProvider
     * @param applicationPropertiesService
     */
    function DummyMessageService(http, currentLanguageProvider, applicationPropertiesService) {
        var _this = this;
        this.http = http;
        this.currentLanguageProvider = currentLanguageProvider;
        this.applicationPropertiesService = applicationPropertiesService;
        this.messagesApiUrlKey = 'messages-service-url';
        this.messagesByLanguage = new Map();
        this.currentLanguageMessages = new ReplaySubject_1.ReplaySubject(3);
        this.applicationPropertiesService
            .getProperty(this.messagesApiUrlKey)
            .then(function (uri) { return currentLanguageProvider
            .getCurrentLanguage()
            .subscribe(function (language) { return _this.loadMessages(language.getId(), uri); }); })
            .catch(DummyMessageService_1.handleError);
    }
    DummyMessageService_1 = DummyMessageService;
    /**
     *
     * @param messageKey
     * @returns String message which is associated with this messageKey
     */
    DummyMessageService.prototype.getMessage = function (messageKey) {
        return this.currentLanguageMessages.map(function (messages) {
            return messages.get(messageKey);
        });
    };
    DummyMessageService.prototype.getMessagesByCriteria = function (messageSearchCriteria) {
        throw new Error('Not Implemented');
    };
    DummyMessageService.prototype.getDetailedMessagesByCriteria = function (messageSearchCriteria) {
        throw new Error('Not Implemented');
    };
    /**
     *
     * @param messageKey
     * @param placeholders
     * @returns {ErrorObservable}
     */
    DummyMessageService.prototype.getMessageWithPlaceholder = function (messageKey, placeholders) {
        return this.currentLanguageMessages.map(function (messages) {
            return DummyMessageService_1.replacePlaceHolders(messages.get(messageKey), placeholders);
        });
    };
    /**
     * @param languageId
     * @param messageKeys
     * @returns Array of messages which is associated with this array of messageKeys
     */
    DummyMessageService.prototype.getMessages = function (languageId, messageKeys) {
        var messages = this.messagesByLanguage.get(languageId) || new Map();
        return Promise.resolve(messages);
    };
    DummyMessageService.prototype.getMessagesWithPlaceholder = function (languageId, messageKeys, placeholders) {
        return this.getMessages(languageId, messageKeys).then(function (messagesByKeys) {
            return new Map(Array.from(messagesByKeys).map(function (_a, index) {
                var key = _a[0], message = _a[1];
                return [key, DummyMessageService_1.replacePlaceHolders(message, placeholders[index])];
            }));
        });
    };
    DummyMessageService.prototype.partialUpdateMessages = function (messages) {
        throw new Error('Not Implemented');
    };
    /**
     * Loads messages from backend or just retrieves messages if they have been already loaded into subject
     * @private
     */
    DummyMessageService.prototype.loadMessages = function (languageId, messagesApiUrl) {
        var _this = this;
        if (this.messagesByLanguage.get(languageId)) {
            this.currentLanguageMessages.next(this.messagesByLanguage.get(languageId));
        }
        else {
            var dataPromise = this.http.get(messagesApiUrl).toPromise();
            dataPromise.then(function (res) {
                var messages = _this.extractMessages(res);
                messages.forEach(function (value, langId) { return _this.messagesByLanguage.set(langId, value); });
                _this.currentLanguageMessages.next(messages.get(languageId));
            }).catch(DummyMessageService_1.handleError);
        }
    };
    /**
     * Extracts messages from response
     * @param data Response
     * @returns {Map<string,string>} messages
     */
    DummyMessageService.prototype.extractMessages = function (data) {
        return Object.keys(data).reduce(function (acc, key) {
            acc.set(Number(key), DummyMessageService_1.convertObjectToMap(data[key]));
            return acc;
        }, new Map());
    };
    /**
     * Converts Object to Map
     * @param obj
     * @returns {Map<number, string>}
     */
    DummyMessageService.convertObjectToMap = function (obj) {
        var strMap = new Map();
        for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
            var k = _a[_i];
            strMap.set(k, obj[k]);
        }
        return strMap;
    };
    /**
     * Handle errors
     */
    DummyMessageService.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    /**
     * Get Message value from map and replace placeholders
     * @returns Message value for current messageKey
     */
    DummyMessageService.replacePlaceHolders = function (messageKey, placeholders) {
        if (placeholders != null && placeholders.length !== 0) {
            for (var i = 0; i < placeholders.length; i++) {
                var placeholder = placeholders[i];
                messageKey = messageKey.replace('{' + i + '}', placeholder);
            }
        }
        return messageKey;
    };
    DummyMessageService = DummyMessageService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient, idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], DummyMessageService);
    return DummyMessageService;
    var DummyMessageService_1;
}());
exports.DummyMessageService = DummyMessageService;
//# sourceMappingURL=dummy-message.service.js.map